export var PACKAGE_VERSION = '3.0.0 (676b6fe5)';
export var THEME = 'polaris';
